import { Form, Formik } from "formik";

import Button from "../../components/common/button/Button";
import Title from "../../components/common/title/Title";
import Input from "../../components/common/inputs/Input";
import Select from "../../components/common/inputs/Select";
import { useLocation, useNavigate } from "react-router";
import { useEffect, useRef, useState } from "react";
import { postApi, putApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import CurrencyInput from "../../components/common/inputs/CurrencyInput";
import { shippingValidation } from "../../utils/validations/shippingValidation";
import FreeForRoles from "./sub-components/free-for-roles/FreeForRoles";
import FreeGteThanPrice from "./sub-components/free-gte-than-price/FreeGteThanPrice";

export default function ProductShipping() {
  const location = useLocation();
  const navigate = useNavigate();

  const [freeForRoles, setFreeForRoles] = useState(null);
  const [freeGteThanPrice, setFreeGteThanPrice] = useState(null);
  const priceRef = useRef();

  const formHandler = async (values, { resetForm }) => {
    const body = {
      ...values,
      isDefault: values.isDefault === "false" ? false : true,
      freeForAll: values.freeForAll === "false" ? false : true,
      freeGteThanPrice,
      freeForRoles,
      price: Number(values.price),
      cashOnDeliveryGteWeight: {
        value: Number(values.cashOnDeliveryGteWeight) || 0,
      },
    };
    try {
      if (location.state) {
        const path = `admin/shipings/${location.state.id}`;
        const data = await putApi({ path, body });
        console.log(data);
        successMessage("حمل و نقل با موفقیت ویرایش شد");
      } else {
        const path = "admin/shipings";
        const data = await postApi({ path, body });
        console.log(data);
        successMessage("حمل و نقل با موفقیت اضافه شد");
      }
      navigate("/product-shipping-list");
      resetForm();
      priceRef.current.afterSubmit();
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  const FreeForRolesRef = useRef();
  const FreeForPriceRef = useRef();

  const handleRoles = (data) => {
    console.log(data);
    setFreeForRoles(data);
  };
  const handlePriceّ = (data) => {
    console.log(data);
    setFreeGteThanPrice(data);
  };

  useEffect(() => {
    if (location?.state?.freeForRoles) {
      const newNeProduct = location?.state?.freeForRolesNe?.map((item) => {
        return item._id;
      });
      setFreeForRoles({
        rolse: location?.state?.freeForRoles,
        neProduct: newNeProduct,
      });
    }
    if (location?.state?.freeGteThanPrice) {
      const newNeProduct = location?.state?.freeGteThanPriceNe?.map((item) => {
        return item._id;
      });
      setFreeGteThanPrice({
        value: location?.state?.value,
        neProduct: newNeProduct,
      });
    }
  }, [location.state]);

  console.log(location.state);
  console.log(freeForRoles);
  console.log(freeGteThanPrice);

  useEffect(() => {
    if (location.pathname === "/add-product-shipping") {
      priceRef.current.afterSubmit();
    }
  }, [location.pathname]);

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6 relative">
      <Title title={location.state ? "ویرایش حمل و نقل" : "افزودن حمل و نقل"} />
      <div className="mt-6">
        <Formik
          enableReinitialize
          initialValues={{
            name: location?.state?.name || "",
            price: location?.state?.price || 0,
            status: location?.state?.status || "active",
            isDefault: location?.state?.isDefault || "false",
            freeForAll: location?.state?.freeForAll || "false",
            cashOnDeliveryGteWeight:
              location?.state?.cashOnDeliveryGteWeight || "",
          }}
          validationSchema={shippingValidation}
          onSubmit={formHandler}
        >
          {(formik) => (
            <Form>
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Input name="name" placeholder="نام" label="نام" type="text" />
                <div>
                  <label
                    for="large-input"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    قیمت
                  </label>
                  <CurrencyInput
                    placeholder="قیمت"
                    name="price"
                    ref={priceRef}
                    inputValue={formik.values["price"]}
                    onChange={(e) => formik.setFieldValue("price", e)}
                  />
                  {formik.errors.price && formik.touched.price ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.price}
                    </p>
                  ) : null}
                </div>

                <Select name="status" placeholder="وضعیت" label="وضعیت">
                  <option value={"active"}>فعال</option>
                  <option value={"pending"}>در حال بررسی</option>
                  <option value={"inactive"}>غیر فعال</option>
                </Select>

                <Select
                  name="isDefault"
                  placeholder="حمل و نقل پیش فرض"
                  label="حمل و نقل پیش فرض"
                >
                  <option value={true}>بله</option>
                  <option value={false}>خیر</option>
                </Select>

                <Select
                  name="freeForAll"
                  placeholder="رایگان برای همه"
                  label="رایگان برای همه"
                >
                  <option value={true}>بله</option>
                  <option value={false}>خیر</option>
                </Select>

                <Input
                  name="cashOnDeliveryGteWeight"
                  placeholder="آستانه وزن پس‌کرایه (گرم)"
                  label="آستانه وزن پس‌کرایه (گرم)"
                  type="number"
                />

                <div className="flex items-end">
                  <button
                    onClick={() => FreeForRolesRef.current.showModal()}
                    type="button"
                    className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2"
                  >
                    رایگان برای نقش
                  </button>
                  <button
                    onClick={() => FreeForPriceRef.current.showModal()}
                    type="button"
                    className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2"
                  >
                    رایگان برای قیمت
                  </button>
                </div>
              </div>
              <div className="flex flex-col gap-y-2">
                <div className="mt-6">
                  <Button
                    text={
                      location?.state
                        ? "ویرایش حمل و نقل"
                        : "ایجاد حمل و نقل جدید"
                    }
                    color={"success"}
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>

        <FreeForRoles ref={FreeForRolesRef} handleFreeForRoles={handleRoles} />
        <FreeGteThanPrice
          ref={FreeForPriceRef}
          handleFreeGteThanPrice={handlePriceّ}
        />
      </div>
    </div>
  );
}
